import { render, staticRenderFns } from "./BlockThree.vue?vue&type=template&id=0bf54f60&scoped=true&"
import script from "./BlockThree.vue?vue&type=script&lang=js&"
export * from "./BlockThree.vue?vue&type=script&lang=js&"
import style0 from "./BlockThree.vue?vue&type=style&index=0&id=0bf54f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf54f60",
  null
  
)

export default component.exports